<template>
  <v-card elevation="6" ref="card" class="rounded-lg d-flex flex-column flex-grow-1" max-height="500px">
    <v-overlay :value="loaderOverlay" :absolute="true">
      <v-row justify="center">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-row>
    </v-overlay>
    <v-card-title>
      <v-icon left>mdi-account-box-multiple-outline</v-icon>
      {{ $t("presencelist") }}
    </v-card-title>
    <v-card-text ref="cardText" class="flex-grow-1">
      <v-container class="pr-0 d-flex flex-wrap">
        <div v-for="user in presenceListUsers" class="px-4 mb-2" :key="user.sapEmpId">
          <v-card
            :width="200"
            :height="50"
            rounded="r-xl"
            flat
            :color="$vuetify.theme.dark ? '#323131' : 'grey lighten-3'"
            :style="`border-bottom: 5px solid ${user.color} !important;`"
          >
            <div class="d-flex flex-row">
              <v-img :min-width="50" :max-width="50" :min-height="50" :max-height="50" :src="user.profilePicture" />
              <div>
                <v-card-text class="pt-0 pl-2 pb-0">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on" class="name-ellipsis">{{ user.name }}</span>
                    </template>
                    <span>{{ user.name }}</span>
                  </v-tooltip>
                </v-card-text>
                <!--v-card-subtitle class="pt-0 pl-2 pb-2">
                  {{ user.department }}
                </v-card-subtitle-->
              </div>
            </div>
          </v-card>
        </div>
      </v-container>
    </v-card-text>
    <v-card-actions align="end">
      <v-row justify="end" class="px-6 pb-6">
        <v-btn
          v-if="this.$store.getters['user/user'].userGroupRights.canAccessPresenceList"
          rounded
          color="#990000"
          style="color: white"
          @click="$router.push('PresenceList')"
          >{{ $t("showAll") }}</v-btn
        >
      </v-row>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "MiniPresenceList",
  data() {
    return {
      presenceListUsers: [],
      allUsers: [],
      loaderOverlay: false,
      showUserInList: 6,
      interval: 180000,
      timer: null
    };
  },

  async created() {
    this.loaderOverlay = true;
    await this.getMiniPresenceList();
    this.changeVisibleUsers();
    this.loaderOverlay = false;

    for (const user of this.presenceListUsers) {
      if (user.department.length > 20) user.department = user.department.substring(0, 20) + "...";
    }
    this.timer = setTimeout(this.setTimer, this.interval);
  },
  beforeDestroy() {
    clearTimeout(this.timer);
  },

  computed: {
    showUsers() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 1;
        case "sm":
          return 3;
        case "md":
          return 6;
        case "lg":
          return 9;
        case "xl":
          return 12;
        default:
          return 6;
      }
    }
  },
  methods: {
    async visibilityChange() {
      if (!document.hidden) {
        await this.getMiniPresenceList();
      }
    },
    setTimer() {
      this.getMiniPresenceList();
      this.interval = 180000;
      this.timer = setTimeout(this.setTimer, this.interval);
    },
    async getMiniPresenceList() {
      this.allUsers = await this.$store
        .dispatch("users/getPresenceList")
        .then((res) => {
          if (res.data) return res.data;
        })
        .catch((err) => {
          this.$eventHub.$emit("showError", err.response.data.error, "bottom", "right");
        });
      this.sortUser();
    },
    determineColor(status) {
      if (status == "Present") return "green";
      else if (status == "Break") return "#FFBF00";
      else if (status == "Absent") return "#B31616"; // TODO primary und amber implementieren
    },
    sortUser() {
      this.presenceListUsers = [];
      let counter = 0;
      for (const user of this.allUsers) {
        counter++;
        if (counter > this.showUserInList) continue;
        let department = "";
        if (user.teams.length > 0) department = user.teams[0].Team;

        this.presenceListUsers.push({
          name: user.Name,
          sapEmpId: user.SAPEmpID,
          profilePicture: user.userPicture == null ? require("@/res/icon/User.jpg") : user.userPicture,
          color: this.determineColor(user.status),
          department: department
        });
      }
    },
    changeVisibleUsers(e) {
      this.setMaxNumberUserForList();
      this.sortUser();
    },
    setMaxNumberUserForList() {
      let height = Math.floor((this.$refs.card.$el.clientHeight - 126) / 58);
      let width = Math.floor((this.$refs.card.$el.clientWidth - 44) / 232);

      this.showUserInList = height * width;
    }
  }
};
</script>

<style scoped>
.name-ellipsis {
  display: inline-block;
  max-width: 120px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
